
import noData from '~/components/common/noData.vue'
export default {
  name: 'NoData',
  components: {
    'no-data': noData
  },
  asyncData({ res }) {
    res.statusCode = 404
  },
  head() {
    return {
      title: this.$t('22205'),
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.$t('22206')
        }
      ]
    }
  }
}
